import { useCallback, useEffect, useState } from 'react';
import { MobileJourneyPicker } from '../MobileJourneyPicker';
import {
  MobileModalOverlay,
  MobileTrigger,
  MobileTriggerSubtitle,
  MobileTriggerTitle,
} from './JourneyPickerMobile.styles';
import type { JourneyPickerSharedProps } from './JourneyPickerView.types';

export interface JourneyPickerMobileProps extends JourneyPickerSharedProps {
  triggerTitle: string;
  triggerSubtitle?: string;
  closeLabel: string;
}

export function JourneyPickerMobile({
  triggerTitle,
  triggerSubtitle,
  closeLabel,
  showCategory,
  categories,
  category,
  onCategorySelect,
  fromDate,
  toDate,
  isSingleDate,
  onRangeSelect,
  displayGuests,
  adults,
  children,
  onAdultsChange,
  onChildrenChange,
  availability,
  onMonthChange,
  onSearch,
  searchLabel,
  datePickerLabels,
  guestPickerLabels,
  showRate,
  rateCode,
  rateLabels,
  onRateCodeChange,
}: JourneyPickerMobileProps) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    if (typeof document === 'undefined') return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [open]);

  const close = useCallback(() => setOpen(false), []);

  const handleNext = useCallback(() => {
    close();
    onSearch();
  }, [close, onSearch]);

  return (
    <>
      <MobileTrigger
        type="button"
        data-journey-picker-edit-dates
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <MobileTriggerTitle>{triggerTitle}</MobileTriggerTitle>
        {triggerSubtitle && <MobileTriggerSubtitle>{triggerSubtitle}</MobileTriggerSubtitle>}
      </MobileTrigger>

      {open && (
        <MobileModalOverlay role="dialog" aria-modal="true">
          <MobileJourneyPicker
            categories={showCategory ? categories : undefined}
            category={category}
            onCategoryChange={onCategorySelect}
            fromDate={fromDate || null}
            toDate={isSingleDate ? fromDate || null : toDate || null}
            isSingleDate={isSingleDate}
            availability={availability}
            onMonthChange={onMonthChange}
            onRangeSelect={onRangeSelect}
            adults={adults}
            childCount={children}
            onAdultsChange={onAdultsChange}
            onChildrenChange={onChildrenChange}
            showWho={displayGuests}
            defaultOpenSection={showCategory && !category ? 'what' : 'when'}
            onClose={close}
            onNext={handleNext}
            showRate={showRate}
            rateCode={rateCode}
            onRateCodeChange={onRateCodeChange}
            labels={{
              closeAriaLabel: closeLabel,
              next: searchLabel,
              rateCode: rateLabels.placeholder,
              rateApply: rateLabels.apply,
              rateClear: rateLabels.clear,
              calendar: datePickerLabels,
              guestPicker: guestPickerLabels,
            }}
          />
        </MobileModalOverlay>
      )}
    </>
  );
}
